module.exports = __webpack_public_path__ + "assets/img/warrior-name-b0027b5e.png";